export default "__VITE_ASSET__DuoU0kp0__"